/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DescribeProjectMutationVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  requestId: Types.Scalars["String"]["input"];
}>;

export type DescribeProjectMutation = {
  readonly __typename: "Mutation";
  readonly describeProject: {
    readonly __typename: "DescribeProjectResult";
    readonly description: string | null;
    readonly responseOverride: string | null;
  };
};

export type DescribeProjectStreamSubscriptionVariables = Types.Exact<{
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  requestId: Types.Scalars["String"]["input"];
}>;

export type DescribeProjectStreamSubscription = {
  readonly __typename: "Subscription";
  readonly describeProjectStream: {
    readonly __typename: "DescribeProjectStreamPayload";
    readonly token: string | null;
    readonly done: boolean;
    readonly error: string | null;
  };
};

export const DescribeProjectDocument = /*#__PURE__*/ gql`
  mutation DescribeProject($hexVersionId: HexVersionId!, $requestId: String!) {
    describeProject(hexVersionId: $hexVersionId, requestId: $requestId) {
      description
      responseOverride
    }
  }
`;
export type DescribeProjectMutationFn = Apollo.MutationFunction<
  DescribeProjectMutation,
  DescribeProjectMutationVariables
>;

/**
 * __useDescribeProjectMutation__
 *
 * To run a mutation, you first call `useDescribeProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDescribeProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [describeProjectMutation, { data, loading, error }] = useDescribeProjectMutation({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useDescribeProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DescribeProjectMutation,
    DescribeProjectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DescribeProjectMutation,
    DescribeProjectMutationVariables
  >(DescribeProjectDocument, options);
}
export type DescribeProjectMutationHookResult = ReturnType<
  typeof useDescribeProjectMutation
>;
export type DescribeProjectMutationResult =
  Apollo.MutationResult<DescribeProjectMutation>;
export type DescribeProjectMutationOptions = Apollo.BaseMutationOptions<
  DescribeProjectMutation,
  DescribeProjectMutationVariables
>;
export const DescribeProjectStreamDocument = /*#__PURE__*/ gql`
  subscription DescribeProjectStream(
    $hexVersionId: HexVersionId!
    $requestId: String!
  ) {
    describeProjectStream(hexVersionId: $hexVersionId, requestId: $requestId) {
      token
      done
      error
    }
  }
`;

/**
 * __useDescribeProjectStreamSubscription__
 *
 * To run a query within a React component, call `useDescribeProjectStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDescribeProjectStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescribeProjectStreamSubscription({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useDescribeProjectStreamSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    DescribeProjectStreamSubscription,
    DescribeProjectStreamSubscriptionVariables
  > &
    (
      | {
          variables: DescribeProjectStreamSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    DescribeProjectStreamSubscription,
    DescribeProjectStreamSubscriptionVariables
  >(DescribeProjectStreamDocument, options);
}
export type DescribeProjectStreamSubscriptionHookResult = ReturnType<
  typeof useDescribeProjectStreamSubscription
>;
export type DescribeProjectStreamSubscriptionResult =
  Apollo.SubscriptionResult<DescribeProjectStreamSubscription>;
